import type { TLShape } from "@tldraw/tlschema";

// Rendering rules shared by the board canvas and its read-only renderers.

/** Hidden tracing paper (and everything on it) is not drawn. */
export const shapeVisibility = (shape: TLShape) =>
  shape.type === "trace" && shape.props.hidden
    ? ("hidden" as const)
    : ("inherit" as const);
